import { getFetchHeaders } from '../getFetchHeaders';
import { getFetchResponseData } from '../getFetchResponseData';
import * as engineeringTypes from './types';

export const actionCreators = {
  getEngineeringProjectTimeEntries: (
    oid,
    startDate,
    endDate,
    { skipPageLoader = false } = {}
  ) => {
    return async (dispatch) => {
      try {
        dispatch({
          type: engineeringTypes.GET_ENGINEERING_TIME_ENTRIES,
          oid,
          selectedDays: [startDate, endDate],
          isLoading: !skipPageLoader,
        });
        var headers = await getFetchHeaders();
        var url = `api/v2/TimeTracker/projectEntries?UserId=${oid}&StartDate=${startDate}&EndDate=${endDate}`;
        const response = await fetch(url, {
          method: 'GET',
          headers: headers,
        });
        const data = await getFetchResponseData(response);
        dispatch({
          type: engineeringTypes.GET_ENGINEERING_TIME_ENTRIES_SUCCESS,
          payload: data,
          selectedDays: [startDate, endDate],
        });
      } catch (error) {
        dispatch({
          type: engineeringTypes.GET_ENGINEERING_TIME_ENTRIES_ERROR,
          error: error.message,
        });
        throw error;
      }
    };
  },

  upsertEngineeringProjectTimeEntry: (
    userId,
    date,
    hours,
    projectNumber,
    projectId
  ) => {
    return async (dispatch) => {
      try {
        var headers = await getFetchHeaders();
        var url = 'api/v2/TimeTracker/projectEntries/upsert';

        const res = await fetch(url, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify({
            userId,
            date,
            hours,
            projectNumber,
            projectId,
          }),
        });

        const data = await getFetchResponseData(res);

        dispatch({
          type: engineeringTypes.UPSERT_ENGINEERING_TIME_ENTRY_SUCCESS,
          payload: data,
        });
      } catch (error) {
        dispatch({
          type: engineeringTypes.UPSERT_ENGINEERING_TIME_ENTRY_ERROR,
          error: error.message,
        });
        throw error;
      }
    };
  },
  deleteEngineeringProjectTimeEntry: (id) => {
    return async () => {
      var headers = await getFetchHeaders();
      var url = `api/v2/TimeTracker/projectEntries/${id}`;
      return fetch(url, {
        method: 'DELETE',
        headers: headers,
      });
    };
  },
  revertEngineeringTimeEntry: (procedureId, requestId, date, originalHours) => {
    return {
      type: engineeringTypes.REVERT_ENGINEERING_TIME_ENTRY,
      payload: { procedureId, requestId, date, originalHours },
    };
  },
  deleteUserTimesheetProjectBlacklist: (engineeringEntry, userId) => {
    return async (dispatch) => {
      dispatch({
        type: engineeringTypes.ADD_ENGINEERING_ENTRY,
        payload: engineeringEntry,
      });

      try {
        var headers = await getFetchHeaders();
        await fetch(
          `api/v2/TimeTracker/projectEntries/userTimesheetBlacklist/delete`,
          {
            method: 'DELETE',
            headers: headers,
            body: JSON.stringify({
              UserId: userId,
              ProjectId: engineeringEntry.projectId,
            }),
          }
        );

        return;
      } catch (err) {
        return Promise.reject(err);
      }
    };
  },
  addEngineeringEntryBlacklist: (projectId, userId) => {
    return async (dispatch) => {
      dispatch({
        type: engineeringTypes.DELETE_ENGINEERING_ENTRY,
        payload: projectId,
      });

      try {
        const headers = await getFetchHeaders();
        await fetch(
          `api/v2/TimeTracker/projectEntries/userTimesheetBlacklist/add`,
          {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
              UserId: userId,
              ProjectId: projectId,
            }),
          }
        );

        return;
      } catch (err) {
        return Promise.reject(err);
      }
    };
  },
};
